module.exports = __webpack_public_path__ + "assets/5dd94d746c2f52e02693f7818228c29a.png";